import { api } from '../utils/request'

export const airports = async () => {
    const resp = await api({
        endpoint: '/airport',
        method: 'GET',

    })
    return resp
}

export const searchAirports = async (query) => {
    const resp = await api({
        endpoint: '/airport',
        method: 'GET',
        query

    })
    return resp
}
export const searchTrains = async (query) => {
    const resp = await api({
        endpoint: '/railwayStation',
        method: 'GET',
        query

    })
    return resp
}


export const city = async () => {
    const resp = await api({
        endpoint: '/city',
        method: 'GET',

    })
    return resp
}
